import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/MainLayout";

import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Course from "./pages/Course";
import Admission from "./pages/Admission";
import VisionMission from "./pages/VisionMission";
import Why from "./pages/Why";
import Infrastructure from "./pages/Infrastructure";
import Placeholder from "./pages/Placeholder";
import Gallery from "./pages/Gallery";
import Events from "./pages/Events";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />

          {/* Main pages */}
          <Route path="/contact1" element={<Contact />} />
          <Route path="/course" element={<Course />} />
          <Route path="/admission" element={<Admission />} />
          <Route path="/vision_mission" element={<VisionMission />} />
          <Route path="/why_sgmtlkbed" element={<Why />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/events" element={<Events />} />

          {/* Placeholder routes (menu items that were '#' on the original site) */}
          <Route path="/history" element={<Placeholder title="History" />} />
          <Route path="/trustees" element={<Placeholder title="Trustees & Advisory Committee" />} />
          <Route path="/principal" element={<Placeholder title="About Principal" />} />

          <Route path="/laboratory" element={<Placeholder title="Laboratory" />} />
          <Route path="/class-rooms" element={<Placeholder title="Class Rooms" />} />
          <Route path="/comp-lab" element={<Placeholder title="Computer Laboratory" />} />
          <Route path="/psychology" element={<Placeholder title="Psychology Resource Centre" />} />
          <Route path="/science-resource" element={<Placeholder title="Science Resource Centre" />} />
          <Route path="/social-science" element={<Placeholder title="Social Science Resource Centre" />} />
          <Route path="/art-craft" element={<Placeholder title="Art & Craft / Work Experience Room" />} />
          <Route path="/sports" element={<Placeholder title="Sports Facilities" />} />
          <Route path="/hostels" element={<Placeholder title="Hostels" />} />
          <Route path="/new-facilities" element={<Placeholder title="Newly Added Facilities" />} />

          <Route path="/faculty/teaching" element={<Placeholder title="Faculty - Teaching" />} />
          <Route path="/faculty/non-teaching" element={<Placeholder title="Faculty - Non-Teaching" />} />

          <Route path="/mandatory/ncte" element={<Placeholder title="NCTE Order" />} />
          <Route path="/mandatory/state" element={<Placeholder title="State Government Order" />} />
          <Route path="/mandatory/university" element={<Placeholder title="University Notification" />} />
          <Route path="/mandatory/aishe" element={<Placeholder title="AISHE" />} />
          <Route path="/mandatory/audit" element={<Placeholder title="Audit Report" />} />
          <Route path="/admission/fees" element={<Placeholder title="Fees" />} />
          <Route path="/admission/students" element={<Placeholder title="Students" />} />
          <Route path="/course/semester-outline" element={<Placeholder title="Semester Wise Course Outline" />} />

          {/* Backward compatible old URLs */}
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/contact1.aspx" element={<Navigate to="/contact1" replace />} />
          <Route path="/course.aspx" element={<Navigate to="/course" replace />} />
          <Route path="/admission.aspx" element={<Navigate to="/admission" replace />} />
          <Route path="/vision_mission.aspx" element={<Navigate to="/vision_mission" replace />} />
          <Route path="/why_sgmtlkbed.aspx" element={<Navigate to="/why_sgmtlkbed" replace />} />
          <Route path="/infrastructure.aspx" element={<Navigate to="/infrastructure" replace />} />

          {/* fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
